export default __webpack_public_path__ + "375114048d0754f95724902b36eabdd3.svg";